import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import {
  NotFoundComponent,
  UnauthorizedComponent,
  AuthorizeGuard,
  LeaderGuard,
  UnitAdminGuard,
  CampusUnitMessageComponent
} from './shared';
import * as Security from './shared/tokens/roles.tokens';
import { LoginComponent } from './login.component';
import { SelectivePreloadingStrategy } from './selective-preloading-strategy';
import { UnitLoginComponent } from './unit-information/unit-login/unit-login.component';

const routes: Routes = [
  {
    path: 'unauthorized',
    component: UnauthorizedComponent,
    data: { title: 'Access denied' }
  },
  {
    path: 'login',
    component: LoginComponent
  },
  {
    path: 'unit-login',
    component: UnitLoginComponent,
    data: { title: 'Unit login' }
  },
  {
    path: 'admin',
    // 2018-3-1 Angular currently doesn't let CanLoad have the full URL being asked for, so we can't use our guard as a CanLoad... yet; there's a pull request out there so maybe soon?
    canActivate: [AuthorizeGuard],
    // data: {
    //   roles: [
    //     Security.ApplicationRoles.byuiAdmin,
    //     Security.ApplicationRoles.byuiLeader
    //   ]
    // },
    loadChildren: () => import('./admin/admin.module').then(m => m.AdminModule)
  },
  {
    path: 'leader',
    canActivate: [LeaderGuard],
    data: {
      // roles: [
      //   Security.ApplicationRoles.byuiAdmin,
      //   Security.ApplicationRoles.byuiLeader
      // ], // TODO figure out how to secure down to LDS Account too
      preload: true
    },
    loadChildren: () => import('./leader/leader.module').then(m => m.LeaderModule)
  },
  { path: '', redirectTo: 'units', pathMatch: 'full' },
  {
    path: '404',
    component: NotFoundComponent,
    data: { title: 'Page not found' }
  },
  {
    path: '**',
    component: NotFoundComponent,
    data: { title: 'Page not found' }
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
    preloadingStrategy: SelectivePreloadingStrategy,
    relativeLinkResolution: 'legacy'
})
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
